import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

/**
 * Provides the Transloco scope for password show/hide toggle labels.
 *
 * Scope: `shared-password-input` — template prefix `sharedPwd`.
 */
export function provideTranslocoScopeSharedPasswordInput(): Provider {
  return provideTranslocoScope({
    alias: 'sharedPwd',
    loader: i18nLoader,
    scope: 'shared-password-input',
  });
}
